import React from 'react'

const SplashPage = () => (
  <div style={{ padding: '3em', textAlign: 'center' }}>
    <h2>Welcome to Peril</h2>
    <h3>A website for browsing, creating, and hosting Jeopardy-like games</h3>
    <p>This website is a work in progress. It is not fully styled and features are subject to change.</p>
    <p>Please sign up or log in to continue.</p>
  </div>
)

export default SplashPage
